import 'utils/filter_form';
import 'utils/form_data_summary';
import 'utils/autofill_by_query_string';
import 'components/select';
import 'components/contest_status_input';
import 'components/uf_input';
import 'components/region_input';
import './index.scss';

(function ($) {
  const $filterForm = $('#js-contests-filter-form');

  $filterForm
    .filterForm()
    .formDataSummary('.js-summary')
    .autoFillByQueryString()
    .lazyReady();

  $('.js-select-all', $filterForm).on('click', (e) => {
    const $btn = $(e.target);
    const $inputs = $filterForm.find(`[data-group=${$btn.data('target-group')}]`);

    $btn.toggleClass('selected');
    $inputs
      .prop(
        'checked',
        !$inputs.toArray().every(input => $(input).is(':checked'))
      )
      .trigger('change');

  });

  $('.js-btn-group', $filterForm).each((i, elem) => {
    const $elem = $(elem);
    $elem.on('change', '.js-sel', () => {
      $elem.find('.js-select-all').toggleClass(
        'selected',
        $elem.find('.js-sel').toArray().every(input => $(input).is(':checked'))
      );
    });
  });

  $('.js-states-controls', $filterForm).on('change', '[data-region]', (e, params = {}) => {
    if (!params.noReturn) {
      const region = $(e.target).data('region');
      $(`[value=${region}]`)
        .prop(
          'checked',
          $(`[data-region=${region}]`)
            .toArray()
            .every(input => $(input).is(':checked'))
        )
        .trigger('change', {noReturn: true})
      ;
    }
  });

  $('.js-regions-controls', $filterForm).on('change', '[data-states-control]', (e, params = {}) => {
    if (!params.noReturn) {
      const $control = $(e.target);
      $(`[data-region=${$control.val()}]`)
        .prop('checked', $control.is(':checked'))
        .trigger('change', {noReturn: true})
      ;
    }
  });

  $(':checked', $filterForm).trigger('change');
  $('option', $filterForm).filter(':selected').parent().trigger('change');

  $filterForm.on('submit', () => {
    $filterForm.trigger('filterFormToggle');
  });

})(jQuery);
